// extracted by mini-css-extract-plugin
export default {"descriptionButtons":"styles_descriptionButtons__OYoak"};